import { render, staticRenderFns } from "./RoomAndBoardAccommodation.vue?vue&type=template&id=08618e8f&scoped=true"
import script from "./RoomAndBoardAccommodation.vue?vue&type=script&lang=js"
export * from "./RoomAndBoardAccommodation.vue?vue&type=script&lang=js"
import style0 from "./RoomAndBoardAccommodation.vue?vue&type=style&index=0&id=08618e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08618e8f",
  null
  
)

export default component.exports